/* eslint-disable react-hooks/exhaustive-deps */
import { WarningAmberOutlined } from '@mui/icons-material'
import { Alert, AlertTitle, Badge, Divider, Skeleton, Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import axios from 'api/axios'
import i18n from 'lang/idiomas'
import { useContext, useEffect } from 'react'
import { AvisosContext } from '../providers/AvisosProvider'
import AvisoAlert from './AvisoAlert'

const AvisosNotifications = ({ closePopup = () => {} }) => {
  const { forceRefresh, count, avisos, loading, error } = useContext(AvisosContext)
  useEffect(() => {
    forceRefresh()
  }, [])

  const handleClose = (id) => {
    axios
      .post(`/avisos/${id}/`)
      .catch((error) => {})
      .finally(() => {
        forceRefresh()
      })
  }

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        width: {
          xs: '100%',
          sm: '40vw',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxSizing: 'border-box',
          mb: 1,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: {
              xs: '1.3em',
              // md: '2em',
            },
            fontWeight: 'bold',
          }}
        >
          {i18n.t('eparciales.epavisos', { defaultValue: 'Avisos' })}
        </Typography>
        <Box sx={{}}>
          <Badge badgeContent={count}>
            <WarningAmberOutlined
              style={{
                width: '100%',
              }}
            />
          </Badge>
        </Box>
      </Box>
      <Stack spacing={2}>
        <Divider sx={{ mb: 1 }} />
        {avisos && !loading ? (
          avisos.map((aviso, idx) => (
            <AvisoAlert
              key={idx}
              aviso={aviso}
              closable={true}
              minWidth="100%"
              handleClose={handleClose}
            />
          ))
        ) : (
          <></>
        )}
        {!loading && avisos?.length <= 0 ? (
          <Box sx={{ p: 2 }}>
            <Typography
              variant="h1"
              sx={{ opacity: 0.3, fontSize: '1.5em', fontWeight: 'bold', textAlign: 'center' }}
            >
              {i18n.t('noavipdt', { defaultValue: 'No hay avisos pendientes' })}
            </Typography>
          </Box>
        ) : (
          <></>
        )}
        {loading ? (
          <>
            <Skeleton
              sx={{ width: '100%', height: '48px', borderRadius: '1000px' }}
              variant="rounded"
            />
            <Skeleton
              sx={{ width: '100%', height: '48px', borderRadius: '1000px' }}
              variant="rounded"
            />
            <Skeleton
              sx={{ width: '100%', height: '48px', borderRadius: '1000px' }}
              variant="rounded"
            />
            <Skeleton
              sx={{ width: '100%', height: '48px', borderRadius: '1000px' }}
              variant="rounded"
            />
            <Skeleton
              sx={{ width: '100%', height: '48px', borderRadius: '1000px' }}
              variant="rounded"
            />
          </>
        ) : (
          <></>
        )}
        {error && !loading ? (
          <Alert severity="error">
            <AlertTitle>{i18n.t('errconex', { defaultValue: 'Error de conexión' })}</AlertTitle>
            {i18n.t('noobavi', { defaultValue: 'No se han podido obtener los avisos' })}
          </Alert>
        ) : (
          <></>
        )}
      </Stack>
    </Box>
  )
}

export default AvisosNotifications
